import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const HomeV2Router = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/dashboard", { replace: true });
  }, [navigate]);
  return null;
};

export default HomeV2Router;
